import React, { useEffect, useState } from 'react';
// import PaymentServices from '../services/PaymentServices'; // Adjust path as needed
import PaymentServices from '../../services/externalServices/TicketServices/paymentServices';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CompanyDetailServices from '../../services/externalServices/companyServices';
// import { formatToIST } from "../utils/dateFormater";
import * as XLSX from "xlsx";
// import  UploadBankStatement from '../../Payment/UploadBankStatement'
import UploadTicketStatement from '../../Payment/UploadTicketStatement';
import moment from 'moment';




const GSTSplit = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        paymentMode: 'all',
        // transactionStatus: 'all',
        transactionStatus: 'COMPLETED',  // 👈 reset back to COMPLETED
        dateRange: 'today',
        startDate: '',
        endDate: '',
        theatreName: 'all' // <-- New
    });

    const { role = '', accessList = [] } = JSON.parse(localStorage.getItem('admin'));
    const isTicketAdmin = role === 'ticket-admin';
    const theatreName = accessList?.[0];

    const [paymentModes, setPaymentModes] = useState([{ value: 'all', label: 'All Payment Modes' }]);
    const [statusOptions, setStatusOptions] = useState([{ value: 'all', label: 'All Statuses' }]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 500;
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
    const [theatreOptions, setTheatreOptions] = useState([
        { value: 'all', label: 'All Theatres' }
    ]);
    const [originalData, setOriginalData] = useState([]);


    const generateReport = () => {
        const headers = [
            "Booking ID", "Movie", "Theatre", "Show Date", "Show Time",
            "Transaction ID", "Status", "Total Ticket mount", "Amount", "Theatre Base", "Theatre GST",
            "Theatre Earnings", ...(!isTicketAdmin ? [
                "Platform Fee", "Platform GST", "Gateway Charges", "Platform Earnings"
            ] : [])
        ].join(',');

        const csvRows = filteredData.map(item => {
            const row = [
                item.bookingId,
                `"${item.movieName}"`, // Escape quotes if needed
                `"${item.theatreName}"`,
                formatDateToDDMMYYYY(item.showDate),
                item.showTime,
                item.transactionId,
                item.transactionStatus,
                item.price,
                item.perTicketTotal,
                item.perTicketBase,
                (item.perTicketCGST + item.perTicketSGST).toFixed(2),
                (item.perTicketBase + item.perTicketCGST + item.perTicketSGST).toFixed(2),
                // item.totalAmount,
                // item.theatreBaseAmount,
                // item.theatreGstAmount,
                // item.theatrePayable,
                ...(!isTicketAdmin ? [
                    item.platformFee,
                    item.platformGst,
                    item.gatewayCharges,
                    // item.platformEarnings
                    item.platformFee // Changed from item.platformEarnings to item.platformFee
                ] : [])
            ];
            return row.join(',');
        });

        const csvContent = [headers, ...csvRows].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Revenue_Report_${moment().format('YYYY-MM-DD')}.csv`;
        link.click();
        URL.revokeObjectURL(url);
    };


    const getTheatreOptions = (data) => {
        const names = new Set();
        data.forEach(item => {
            if (item.theatreName) {
                names.add(item.theatreName);
            }
        });
        return Array.from(names).map(name => ({
            value: name,
            label: name
        }));
    };


    // useEffect(() => {
    //     const fetchRevenueReport = async () => {
    //         try {
    //             const response = await PaymentServices.getRevenueReportWithGSTSplit(theatreName);
    //             const items = response.data || [];
    //             const theatresFromData = getTheatreOptions(response.data || []);
    //             setData(items);
    //             setOriginalData(items);
    //             // setFilteredData(items);
    //             setFilteredData(items.filter(i =>
    //                 moment(i.showDate, "YYYY/MM/DD").isSame(moment(), 'day')
    //             ));
    //             setPaymentModes([{ value: 'all', label: 'All Payment Modes' }, ...getOptions(items, 'paymentMode')]);

    //             setStatusOptions([{ value: 'all', label: 'All Statuses' }, ...getOptions(items, 'transactionStatus')]);


    //             setTheatreOptions([
    //                 { value: 'all', label: 'All Theatres' },
    //                 ...theatresFromData
    //             ]);
    //         } catch (err) {
    //             setError('Failed to load revenue report');
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     };
    //     fetchRevenueReport();
    // }, []);


    useEffect(() => {
        const fetchRevenueReport = async () => {
            try {
                const response = await PaymentServices.getRevenueReportWithGSTSplit(theatreName);
                console.log('the response of the revenue report', response);

                const rawItems = response.data || [];

                // 🔄 Normalize transactionStatus: SUCCESS ➜ COMPLETED
                // const items = rawItems.map(item => ({
                //   ...item,
                //   transactionStatus: item.transactionStatus?.toUpperCase() === 'SUCCESS' ? 'COMPLETED' : item.transactionStatus
                // }));


                const items = rawItems.map(item => ({
                    ...item,
                    transactionStatus: item.transactionStatus?.toUpperCase() === 'SUCCESS'
                        ? 'COMPLETED'
                        : item.transactionStatus?.toUpperCase() // Normalize ALL statuses to uppercase
                }));


                const theatresFromData = getTheatreOptions(items);
                setData(items);
                setOriginalData(items);

                // setFilteredData(items.filter(i =>
                //   moment(i.showDate, "YYYY/MM/DD").isSame(moment(), 'day')
                // ));

                setPaymentModes([
                    { value: 'all', label: 'All Payment Modes' },
                    ...getOptions(items, 'paymentMode')
                ]);

                setStatusOptions([
                    { value: 'all', label: 'All Statuses' },
                    ...getOptions(items, 'transactionStatus')
                ]);

                setTheatreOptions([
                    { value: 'all', label: 'All Theatres' },
                    ...theatresFromData
                ]);

            } catch (err) {
                setError('Failed to load revenue report');
            } finally {
                setIsLoading(false);
            }
        };

        fetchRevenueReport();
    }, []);





    useEffect(() => {
        applyFilters();
    }, [filters, data]);



    const getOptions = (items, key) => {
        return Array.from(new Set(items.map(item => item[key]))).filter(Boolean).map(val => ({
            value: val,
            label: val
        }));
    };

    const applyFilters = () => {
        let result = [...data];
        if (filters.paymentMode !== 'all') result = result.filter(i => i.paymentMode === filters.paymentMode);
        // if (filters.transactionStatus !== 'all') result = result.filter(i => i.transactionStatus === filters.transactionStatus);



        if (filters.transactionStatus !== 'all') {
            result = result.filter(i =>
                i.transactionStatus?.toUpperCase() === filters.transactionStatus.toUpperCase()
            );
        }




        if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
            const start = moment(filters.startDate).startOf('day');
            const end = moment(filters.endDate).endOf('day');

            result = result.filter(i => {
                const showDate = moment(i.showDate, "YYYY/MM/DD"); // Parse with correct format
                return showDate.isBetween(start, end, undefined, '[]'); // inclusive
            });
        } else if (filters.dateRange !== 'all') {
            const now = moment();
            const start = moment();

            if (filters.dateRange === 'today') {
                start.startOf('day');
            } else if (filters.dateRange === 'yesterday') {
                start.subtract(1, 'day').startOf('day');
            } else if (filters.dateRange === 'week') {
                start.subtract(7, 'days').startOf('day');
            } else if (filters.dateRange === 'month') {
                start.subtract(1, 'month').startOf('day');
            }

            result = result.filter(i => {
                const showDate = moment(i.showDate, "YYYY/MM/DD"); // Parse with correct format
                if (filters.dateRange === 'today') {
                    return showDate.isSame(moment(), 'day'); // Only today, no future dates
                } else if (filters.dateRange === 'yesterday') {
                    return showDate.isSame(start, 'day'); // Only yesterday
                } else {
                    return showDate.isSameOrAfter(start, 'day'); // Week/month: from X days ago onward
                }
            });
        }


        if (filters.theatreName !== 'all') {
            result = result.filter(item => item.theatreName === filters.theatreName);
        }

        setFilteredData(result);
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    //   const resetFilters = () => {
    //     setFilters({
    //       paymentMode: 'all',
    //       transactionStatus: 'all',
    //       dateRange: 'all',
    //       startDate: '',
    //       endDate: ''
    //     });
    //   };


    const resetFilters = () => {
        setFilters({
            paymentMode: 'all',
            // transactionStatus: 'all',
            transactionStatus: 'COMPLETED',  // 👈 reset back to COMPLETED
            dateRange: 'all',
            startDate: '',
            endDate: '',
            theatreName: 'all'
        });
        // setShowMatchedOnly(false);
        // setMatchedTransactions([]);
        setData(originalData); // <- Reset the data back to original
    };


    // const totals = filteredData.reduce((acc, item) => ({
    //     totalAmount: acc.totalAmount + item.totalAmount,
    //     theatrePayable: acc.theatrePayable + item.theatrePayable,
    //     // platformEarnings: acc.platformEarnings + item.platformEarnings,
    //     platformEarnings: acc.platformEarnings + item.platformFee,
    //     count: acc.count + 1
    // }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });


    // const totals = filteredData.reduce((acc, item) => ({
    //     totalAmount: acc.totalAmount + (item.perTicketTotal || 0),
    //     theatrePayable: acc.theatrePayable + (item.perTicketBase || 0) + (item.perTicketCGST || 0) + (item.perTicketSGST || 0),
    //     platformEarnings: acc.platformEarnings + (item.platformFee || 0), // if available
    //     count: acc.count + 1
    //   }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });

    //   const totals = filteredData.reduce((acc, item) => ({
    //     totalAmount: acc.totalAmount + (item.perTicketTotal || 0),
    //     theatrePayable: acc.theatrePayable + (item.perTicketBase || 0) + (item.perTicketCGST || 0) + (item.perTicketSGST || 0),
    //     platformEarnings: acc.platformEarnings + (item.platformFee || 0), // optional
    //     count: acc.count + 1
    //   }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });









    // const seenBookings = new Set();

    // const totals = filteredData.reduce((acc, item) => {
    //     const isNewBooking = !seenBookings.has(item.bookingId);

    //     if (isNewBooking) {
    //         seenBookings.add(item.bookingId);
    //         acc.totalAmount += (item.totalAmount || 0);  // This will now work!
    //     }

    //     acc.theatrePayable += (item.perTicketBase || 0) + (item.perTicketCGST || 0) + (item.perTicketSGST || 0);
    //     acc.platformEarnings += (item.platformFee || 0);
    //     acc.count += 1;

    //     return acc;
    // }, { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });


    const seenSections = new Set();
    const seenBookings = new Set();

    const totals = filteredData.reduce((acc, item) => {
        const sectionKey = `${item.bookingId}-${item.ticketType}`;
        const isFirstInSection = !seenSections.has(sectionKey);

        const isNewBooking = !seenBookings.has(item.bookingId);

        if (isNewBooking) {
            seenBookings.add(item.bookingId);
            acc.totalAmount += (item.totalAmount || 0);  // This will now work!
            acc.theatreBaseAmount += (item.theatreBaseAmount || 0);   // ✅ ADD THIS
        }

        if (isFirstInSection) {
            seenSections.add(sectionKey);

            acc.theatrePayable +=
                (item.sectionBase || 0) +
                (item.sectionCGST || 0) +
                (item.sectionSGST || 0);
        }

        acc.platformEarnings += item.platformFee || 0; // ✅ Add this even if it’s 0

        acc.count += 1;
        // acc.totalAmount += seenSections.has(item.bookingId) ? 0 : (item.totalAmount || 0);

        return acc;
    }, { totalAmount: 0, platformEarnings: 0, theatreBaseAmount:0, theatrePayable: 0, count: 0 });
















    if (isLoading) return <div className="text-center py-8">Loading report...</div>;
    if (error) return <div className="text-center py-8 text-red-500">{error}</div>;


    const formatDateToDDMMYYYY = (dateInput) => {
        if (!dateInput) return '';

        // Handle both string dates and Date objects
        const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

        // Check if the date is valid
        if (isNaN(date.getTime())) return 'Invalid date';

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
        <div className="container mx-auto px-6 py-8 space-y-8">
            <div className="bg-white p-6 rounded-xl shadow border border-gray-200 space-y-6">
                {/* 
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">Filters</h2>
          <button onClick={resetFilters} className="text-sm text-red-600 hover:text-red-800">Clear Filters</button>
          <button
              onClick={generateReport}
              className="px-3 py-1 text-sm text-green-600 hover:text-green-800 border border-green-200 rounded hover:bg-green-50 flex items-center gap-1"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Export CSV
            </button>
        
        </div> */}


                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-semibold text-gray-800">Filters</h2>
                    <div className="flex gap-2">
                        <button
                            onClick={resetFilters}
                            className="px-3 py-1 text-sm text-red-600 hover:text-red-800 border border-red-200 rounded hover:bg-red-50"
                        >
                            Clear Filters
                        </button>
                        <button
                            onClick={generateReport}
                            className="px-3 py-1 text-sm text-green-600 hover:text-green-800 border border-green-200 rounded hover:bg-green-50 flex items-center gap-1"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            Export Excel
                        </button>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Theatre</label>
                        <select
                            name="theatreName"
                            value={filters.theatreName}
                            onChange={handleChange}
                            className="mt-1 p-2 border border-gray-300 rounded w-full"
                        >
                            {theatreOptions.map(option => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700">Payment Mode</label>
                        <select name="paymentMode" value={filters.paymentMode} onChange={handleChange} className="mt-1 p-2 border border-gray-300 rounded w-full">
                            {paymentModes.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Status</label>
                        <select name="transactionStatus" value={filters.transactionStatus} onChange={handleChange} className="mt-1 p-2 border border-gray-300 rounded w-full">
                            {statusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Date Range</label>
                        <select name="dateRange" value={filters.dateRange} onChange={handleChange} className="mt-1 p-2 border border-gray-300 rounded w-full">
                            <option value="today">Today</option> {/* First option */}

                            <option value="yesterday">Yesterday</option>
                            {/* <option value="today">Today</option> */}
                            <option value="week">Last 7 Days</option>
                            <option value="month">Last 30 Days</option>
                            <option value="custom">Custom</option>
                            <option value="all">All Time</option>
                        </select>
                    </div>
                    {filters.dateRange === 'custom' && (
                        <div className="grid grid-cols-2 gap-2">
                            <input type="date" name="startDate" value={filters.startDate} onChange={handleChange} className="p-2 border rounded" />
                            <input type="date" name="endDate" value={filters.endDate} onChange={handleChange} className="p-2 border rounded" />
                        </div>
                    )}
                </div>

                {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="bg-gray-100 p-4 rounded shadow">
            <p className="text-sm text-gray-600">Total Bookings</p>
            <p className="text-xl font-bold">{totals.count}</p>
          </div>
          <div className="bg-gray-100 p-4 rounded shadow">
            <p className="text-sm text-gray-600">Total Revenue</p>
            <p className="text-xl font-bold">₹{totals.totalAmount.toFixed(2)}</p>
          </div>
          <div className="bg-gray-100 p-4 rounded shadow">
            <p className="text-sm text-gray-600">Theatre Payable</p>
            <p className="text-xl font-bold">₹{totals.theatrePayable.toFixed(2)}</p>
          </div>
          {!isTicketAdmin && (
            <div className="bg-gray-100 p-4 rounded shadow">
              <p className="text-sm text-gray-600">Platform Earnings</p>
              <p className="text-xl font-bold">₹{totals.platformEarnings.toFixed(2)}</p>
            </div>
          )}
        </div> */}


                <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
                    {/* Total Bookings Card */}
                    <div className="bg-green-50 p-4 rounded-lg shadow-sm border border-green-100">
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-full bg-green-100 text-green-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-sm font-medium text-green-800">Total Tickets</h4>
                                <p className="text-2xl font-bold text-green-900">{totals.count}</p>
                            </div>
                        </div>
                    </div>

                    {/* Total Revenue Card */}
                    <div className="bg-blue-50 p-4 rounded-lg shadow-sm border border-blue-100">
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-full bg-blue-100 text-blue-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-sm font-medium text-blue-800">Total Revenue</h4>
                                <p className="text-2xl font-bold text-blue-900">₹{totals.totalAmount.toFixed(2)}</p>
                            </div>
                        </div>
                    </div>

      {/* Theatre Payable Card */}
      <div className="bg-yellow-50 p-4 rounded-lg shadow-sm border border-yellow-100">
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-full bg-yellow-100 text-yellow-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-sm font-medium text-yellow-800">Theatre Earnings(without GST)</h4>
                                <p className="text-2xl font-bold text-yellow-900">₹{totals.theatrePayable.toFixed(2)}</p>
                            </div>
                        </div>
                    </div>







                    {/* Theatre Base Amount Card */}
                    <div className="bg-yellow-50 p-4 rounded-lg shadow-sm border border-yellow-100">
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-full bg-yellow-100 text-yellow-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-sm font-medium text-yellow-800">Theatre Earnings(With GST) </h4>
                                <p className="text-2xl font-bold text-yellow-900">₹{totals.theatreBaseAmount.toFixed(2)}</p>
                            </div>
                        </div>
                    </div>

              


                    {/* Theatre Payable Card  After TCS*/}
                    <div className="bg-orange-50 p-4 rounded-lg shadow-sm border border-orange-100">
                        <div className="flex items-center gap-3">
                            <div className="p-2 rounded-full bg-orange-100 text-orange-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-sm font-medium text-orange-800">Theatre Earnings After 1% TCS</h4>
                                {/* <p className="text-2xl font-bold text-orange-900">₹{(totals.theatrePayable * 0.99).toFixed(2)}</p> */}
                                <p className="text-2xl font-bold text-orange-900">₹{(totals.theatreBaseAmount * 0.99).toFixed(2)}</p>
                            </div>
                        </div>
                    </div>



                    {/* Cruze Earnings Card */}

                    {!isTicketAdmin && (
                        <div className="bg-purple-50 p-4 rounded-lg shadow-sm border border-purple-100">
                            <div className="flex items-center gap-3">
                                <div className="p-2 rounded-full bg-purple-100 text-purple-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                    </svg>
                                </div>
                                <div>
                                    <h4 className="text-sm font-medium text-purple-800">Cruze Earnings</h4>
                                    {/* <p className="text-2xl font-bold text-purple-900">₹{totals.platformEarnings.toFixed(2)}</p> */}
                                    <p className="text-2xl font-bold text-purple-900">₹{totals.platformEarnings.toFixed(2)}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>


                <div className="overflow-x-auto">
                    <table className="min-w-full text-sm text-left border border-gray-200">
                        {/* <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border">Booking ID</th>
                <th className="px-4 py-2 border">Movie</th>
                <th className="px-4 py-2 border">Theatre</th>
                <th className="px-4 py-2 border min-w-[160px]">Show Date</th>
                <th className="px-4 py-2 border min-w-[160px]">Show Time</th>
                <th className="px-4 py-2 border">Transaction ID</th>
                <th className="px-4 py-2 border">Status</th>
                <th className="px-4 py-2 border">Amount</th>
                <th className="px-4 py-2 border">Theatre Base</th>
                <th className="px-4 py-2 border">Theatre GST</th>
                <th className="px-4 py-2 border">Theatre Payable</th>
                {!isTicketAdmin && (
                  <>
                    <th className="px-4 py-2 border">Platform Fee</th>
                    <th className="px-4 py-2 border">Platform GST</th>
                    <th className="px-4 py-2 border">Gateway Charges</th>
                    <th className="px-4 py-2 border">Platform Earnings</th>
                  </>
                )}
              </tr>
            </thead> */}

                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-4 py-2 border">Booking ID</th>
                                <th className="px-4 py-2 border">Movie</th>
                                <th className="px-4 py-2 border">Theatre</th>
                                <th className="px-4 py-2 border min-w-[160px]">Show Date</th>
                                <th className="px-4 py-2 border min-w-[160px]">Show Time</th>
                                <th className="px-4 py-2 border">Transaction ID</th>
                                <th className="px-4 py-2 border">Status</th>
                                <th className="px-4 py-2 border">Section</th>
                                <th className="px-4 py-2 border">Count</th>
                                <th className="px-4 py-2 border">Amount</th>
                                <th className="px-4 py-2 border">Base</th>
                                <th className="px-4 py-2 border">CGST</th>
                                <th className="px-4 py-2 border">SGST</th>
                                <th className="px-4 py-2 border">Section Total</th>

                                {!isTicketAdmin && (
                                    <>
                                        <th className="px-4 py-2 border">Platform Fee</th>
                                        <th className="px-4 py-2 border">Platform GST</th>
                                        <th className="px-4 py-2 border">Gateway Charges</th>
                                        {/* <th className="px-4 py-2 border">Platform Earnings</th> */}
                                    </>
                                )}

                                <th className="px-4 py-2 border">Convenience Fee</th>
                                <th className="px-4 py-2 border">Convenience GST</th>
                                {!isTicketAdmin && (
                                    <>
                                        {/* <th className="px-4 py-2 border">Platform Fee</th>
                                        <th className="px-4 py-2 border">Platform GST</th>
                                        <th className="px-4 py-2 border">Gateway Charges</th> */}
                                        <th className="px-4 py-2 border">Platform Earnings</th>
                                    </>
                                )}
                            </tr>
                        </thead>



                        {/* <tbody>
              {paginatedData.map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border">{item.bookingId}</td>
                  <td className="px-4 py-2 border">{item.movieName}</td>
                  <td className="px-4 py-2 border">{item.theatreName}</td>
                  <td className="px-4 py-2 border min-w-[160px]">{formatDateToDDMMYYYY(item.showDate)}</td>
                  <td className="px-4 py-2 border min-w-[160px]">{item.showTime}</td>
                  <td className="px-4 py-2 border font-mono">{item.transactionId}</td>
                  <td className="px-4 py-2 border">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${item.transactionStatus === 'Success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                      {item.transactionStatus}
                    </span>
                  </td>
                  <td className="px-4 py-2 border">₹{item.totalAmount}</td>
                  <td className="px-4 py-2 border">₹{item.theatreBaseAmount}</td>
                  <td className="px-4 py-2 border">₹{item.theatreGstAmount}</td>
                  <td className="px-4 py-2 border">₹{item.theatrePayable}</td>
                  {!isTicketAdmin && (
                    <>
                      <td className="px-4 py-2 border">₹{item.platformFee}</td>
                      <td className="px-4 py-2 border">₹{item.platformGst}</td>
                      <td className="px-4 py-2 border">₹{item.gatewayCharges}</td>
                      <td className="px-4 py-2 border">₹{item.platformFee}</td>
                    </>
                  )}
                </tr>
              ))}
            </tbody> */}


                        <tbody>
                            {paginatedData.map((item, idx) => (

                                // if (item) {
                                //     console.warn('Undefined item at index', item);
                                //     // return null;
                                // }


                                // console.warn('Undefined item at index', item)


                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-4 py-2 border">{item.bookingId}</td>
                                    <td className="px-4 py-2 border">{item.movieName}</td>
                                    <td className="px-4 py-2 border">{item.theatreName}</td>

                                    <td className="px-4 py-2 border">{formatDateToDDMMYYYY(item.showDate)}</td>
                                    <td className="px-4 py-2 border">{item.showTime}</td>
                                    <td className="px-4 py-2 border font-mono">{item.transactionId}</td>
                                    <td className="px-4 py-2 border">
                                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${item.transactionStatus === 'Success' || item.transactionStatus === 'COMPLETED' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                            {/* {item.transactionStatus} */}
                                            {item.transactionStatus?.toLowerCase() === 'success' ? 'COMPLETED' : item.transactionStatus || ''}
                                        </span>
                                    </td>

                                    <td className="px-4 py-2 border">{item.ticketType}</td>
                                    {/* <td className="px-4 py-2 border">{item.count}</td>
                                    <td className="px-4 py-2 border">₹{item.sectionBase?.toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{item.sectionCGST?.toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{item.sectionSGST?.toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{item.sectionTotal?.toFixed(2)}</td> */}

                                    <td className="px-4 py-2 border">1</td>
                                    {/* <td className="px-4 py-2 border">₹{item.perTicketBase?.toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{item.perTicketCGST?.toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{item.perTicketSGST?.toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{item.perTicketTotal?.toFixed(2)}</td> */}


                                    <td className="px-4 py-2 border">₹{item?.price}</td>
                                    <td className="px-4 py-2 border">₹{(item.perTicketBase ?? 0).toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{(item.perTicketCGST ?? 0).toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{(item.perTicketSGST ?? 0).toFixed(2)}</td>
                                    <td className="px-4 py-2 border">₹{(item.perTicketTotal ?? 0).toFixed(2)}</td>


                                    {!isTicketAdmin && (
                                        <>
                                            <td className="px-4 py-2 border">₹{item.platformFee}</td>
                                            <td className="px-4 py-2 border">₹{item.platformGst}</td>
                                            <td className="px-4 py-2 border">₹{item.gatewayCharges}</td>
                                            {/* <td className="px-4 py-2 border">₹{item.platformFee}</td> */}
                                        </>
                                    )}

                                    <td className="px-4 py-2 border">
                                        {item.perTicketConvenienceFee ? `₹${item.perTicketConvenienceFee}` : ''}
                                    </td>
                                    <td className="px-4 py-2 border">
                                        {item.perTicketConvenienceGst ? `₹${item.perTicketConvenienceGst}` : ''}
                                    </td>

                                    {!isTicketAdmin && (
                                        <>
                                            {/* <td className="px-4 py-2 border">₹{item.platformFee}</td>
                                            <td className="px-4 py-2 border">₹{item.platformGst}</td>
                                            <td className="px-4 py-2 border">₹{item.gatewayCharges}</td> */}
                                            <td className="px-4 py-2 border">₹{item.platformFee}</td>
                                        </>
                                    )}

                                </tr>
                            ))}
                            {/* })} */}
                        </tbody>



                    </table>
                </div>

                <div className="flex justify-between items-center">
                    <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50">Previous</button>
                    <span className="text-sm text-gray-600">Page {currentPage} of {totalPages}</span>
                    <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50">Next</button>
                </div>

                {/* <div className="mt-6">
          <UploadTicketStatement />
        </div> */}
            </div>
        </div>
    );
};





export default GSTSplit;



